(function () {
  'use strict';

  // 权益说明走全局共用弹窗，不内联展开（对齐设计稿）
  var infoModal = null;

  function getInfoModal() {
    if (infoModal) return infoModal;

    infoModal = document.createElement('dialog');
    infoModal.className = 'comu-info-modal';
    infoModal.innerHTML =
      '<button type="button" class="comu-info-modal__close" aria-label="Close">&times;</button>' +
      '<h2 class="comu-info-modal__title"></h2>' +
      '<div class="comu-info-modal__body"></div>';
    document.body.appendChild(infoModal);

    infoModal.querySelector('.comu-info-modal__close').addEventListener('click', function () {
      infoModal.close();
    });
    infoModal.addEventListener('click', function (event) {
      if (event.target === infoModal) infoModal.close();
    });

    return infoModal;
  }

  function initBenefits(root) {
    if (root.dataset.comuBenefitsReady === 'true') return;
    root.dataset.comuBenefitsReady = 'true';

    Array.prototype.forEach.call(root.querySelectorAll('.comu-ba__item'), function (item) {
      var summary = item.querySelector('.comu-ba__summary');
      var details = item.querySelector('.comu-ba__details');
      if (!summary || !details) return;

      summary.addEventListener('click', function () {
        var modal = getInfoModal();
        var icon = item.querySelector('.comu-ba__icon');
        var title = item.querySelector('.comu-ba__title');

        var titleEl = modal.querySelector('.comu-info-modal__title');
        titleEl.textContent = '';
        if (icon) {
          var img = document.createElement('img');
          img.src = icon.getAttribute('src');
          img.alt = '';
          titleEl.appendChild(img);
        }
        var titleText = document.createElement('span');
        titleText.textContent = title ? title.textContent : '';
        titleEl.appendChild(titleText);

        modal.querySelector('.comu-info-modal__body').innerHTML = details.innerHTML;
        modal.showModal();
      });
    });
  }

  function initDescription(root) {
    if (root.dataset.comuDescriptionReady === 'true') return;
    root.dataset.comuDescriptionReady = 'true';

    var toggle = root.querySelector('[data-comu-description-toggle]');
    var label = root.querySelector('[data-comu-description-label]');
    var list = root.querySelector('.comu-desc__body ul, .comu-desc__body ol');
    if (!toggle || !list) return;

    var visible = parseInt(getComputedStyle(root).getPropertyValue('--comu-desc-visible'), 10) || 6;
    var items = Array.prototype.slice.call(list.children);
    if (items.length <= visible) return;

    items.slice(visible).forEach(function (li) {
      li.setAttribute('data-comu-desc-hidden', '');
    });
    toggle.hidden = false;

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded ? root.dataset.lessLabel : root.dataset.moreLabel;
      }
    });
  }

  // 图廊媒体类型切换。主题的图廊是单条轮播，所以点击标签是滚到该类型
  // 的第一条媒体，反过来滚动时也把当前媒体的类型标记为选中。
  function initMediaTabs(root) {
    if (root.dataset.comuMediaTabsReady === 'true') return;
    root.dataset.comuMediaTabsReady = 'true';

    var carousel = document.getElementById(root.dataset.carousel);
    if (!carousel) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.comu-media-tabs__tab'));
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-media-type]'));
    if (!tabs.length || !slides.length) return;

    function markActive(type) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.mediaType === type;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = slides.filter(function (slide) {
          return slide.dataset.mediaType === tab.dataset.mediaType;
        })[0];
        if (!target) return;
        carousel.scrollTo({ left: target.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
        markActive(tab.dataset.mediaType);
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) markActive(entry.target.dataset.mediaType);
        });
      },
      { root: carousel, threshold: 0.6 }
    );
    slides.forEach(function (slide) { observer.observe(slide); });
  }

  // 主图自动轮播。切换走主题 media-carousel 的 select()，不自己动滚动条，
  // 否则会和它的滚动吸附与索引同步打架。
  function initGalleryAutoplay(carousel) {
    if (carousel.dataset.comuAutoplayReady === 'true') return;
    carousel.dataset.comuAutoplayReady = 'true';

    var interval = parseInt(carousel.dataset.comuAutoplay, 10);
    if (!interval || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var gallery = carousel.closest('product-gallery') || carousel;
    var timer = null;

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    // 只在图片之间轮播：切到视频或 3D 时当前项不在图片列表里，自然停下来交给用户操作。
    function advance() {
      var images = carousel.visibleItems.filter(function (item) {
        return item.dataset.mediaType === 'image';
      });
      var index = images.indexOf(carousel.selectedSlide);
      if (images.length < 2 || index === -1) return;

      var next = images[(index + 1) % images.length];
      carousel.select(carousel.items.indexOf(next));
    }

    function start() {
      stop();
      timer = setInterval(advance, interval);
    }

    gallery.addEventListener('pointerenter', stop);
    gallery.addEventListener('pointerleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', start);

    // 触屏没有悬停，点完缩略图后重新计时，避免刚点完就被切走
    gallery.addEventListener('pointerup', function (event) {
      if (event.pointerType !== 'mouse') start();
    });

    // 滚出视口就停，不在后台空转
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) start();
      else stop();
    }).observe(carousel);
  }

  // ComuCare 延保：两个方案互斥，勾选后与主商品一起作为独立行项目加购。
  function initCare(root) {
    if (root.dataset.comuCareReady === 'true') return;
    root.dataset.comuCareReady = 'true';

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-comu-care-option]'));

    options.forEach(function (option) {
      option.addEventListener('change', function () {
        if (option.checked) {
          options.forEach(function (other) {
            if (other !== option) other.checked = false;
          });
        }
      });
    });

    var openBtn = root.querySelector('[data-comu-care-open]');
    var modal = root.querySelector('[data-comu-care-modal]');
    if (openBtn && modal) {
      openBtn.addEventListener('click', function () { modal.showModal(); });
      var closeBtn = modal.querySelector('[data-comu-care-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.close();
      });
    }
  }

  function selectedCareVariant(form) {
    var section = (form && form.closest('.shopify-section')) || document;
    var checked =
      section.querySelector('[data-comu-care-option]:checked') ||
      document.querySelector('[data-comu-care-option]:checked');
    return checked ? checked.dataset.variantId : null;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function cartAddUserMessage(status, json) {
    if (status !== 429 && json && (json.description || json.message)) {
      return json.description || json.message;
    }
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var ja = lang.indexOf('ja') === 0;
    if (status === 429) {
      return ja
        ? 'ただいまアクセスが集中しています。数秒待ってからもう一度お試しください。'
        : 'Too many requests. Please wait a few seconds and try again.';
    }
    return ja
      ? 'カートに追加できませんでした。時間をおいて再度お試しください。'
      : 'Could not add to cart. Please try again shortly.';
  }

  async function readJsonResponse(response, label) {
    var raw = await response.text();
    try {
      return { json: JSON.parse(raw), raw: raw };
    } catch (parseError) {
      console.error('[comu-buybox]', label, response.status, raw.slice(0, 120));
      throw new Error(cartAddUserMessage(response.status, null));
    }
  }

  // 只打一次。429 重试会被 Kaching 再乘一次，三台套餐会变成连打 /cart/add。
  // ?kaching_bundles=true 是插件官方逃生舱，加延保必须带上。
  async function postCartAdd(payload, options) {
    var url = Shopify.routes.root + 'cart/add.js';
    if (options && options.skipKaching) url += '?kaching_bundles=true';

    var response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
    var parsed = await readJsonResponse(response, 'cart/add');
    if (!response.ok) throw new Error(cartAddUserMessage(response.status, parsed.json));
    return parsed.json;
  }

  async function fetchCartSafe() {
    var response = await fetch(Shopify.routes.root + 'cart.js');
    var raw = await response.text();
    try {
      return JSON.parse(raw);
    } catch (parseError) {
      return null;
    }
  }

  function readMainId(form) {
    var idInput = form.elements.id;
    if (!idInput) return null;
    if (typeof idInput.length === 'number' && !idInput.tagName) {
      var picked = Array.prototype.filter.call(idInput, function (el) {
        return el.checked || el.type === 'hidden' || el.tagName === 'INPUT';
      })[0];
      idInput = picked || idInput[0];
    }
    var mainId = idInput && idInput.value;
    return mainId && !isNaN(Number(mainId)) ? mainId : null;
  }

  function formHasBundle(form) {
    var found = false;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('kaching') === -1) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value) found = true;
    });
    if (found) return true;
    var injected = document.querySelector('[name="properties[__kaching_bundles]"]');
    if (injected && injected.value) return true;
    var root = document.querySelector('kaching-bundles-block, kaching-bundles-bar');
    if (!root) return false;
    var visibleSelects = 0;
    Array.prototype.forEach.call(root.querySelectorAll('select'), function (sel) {
      if (sel.offsetParent !== null) visibleSelects += 1;
    });
    return visibleSelects >= 2;
  }

  var warrantyFollowUp = null;
  var warrantyFulfilling = false;

  function armWarrantyFollowUp(form, careVariantId) {
    if (warrantyFollowUp || warrantyFulfilling) return;
    warrantyFollowUp = {
      form: form,
      careVariantId: careVariantId,
      mainId: readMainId(form)
    };
    setTimeout(function () {
      if (warrantyFollowUp && warrantyFollowUp.form === form) warrantyFollowUp = null;
    }, 12000);
  }

  async function fulfillWarrantyFollowUp(detail) {
    var job = warrantyFollowUp;
    if (!job || !job.mainId || warrantyFulfilling) {
      warrantyFollowUp = null;
      return;
    }
    warrantyFollowUp = null;
    warrantyFulfilling = true;

    // 勾选的是一份保护プラン，按 1 件加。不能用主机台数或整车数量，
    // 否则三台套餐第一次会加 3 份，第二次连车上已有主机一起算会加到 9 份。
    await wait(800);

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );

    try {
      var careJson = await postCartAdd(
        {
          items: [
            {
              id: Number(job.careVariantId),
              quantity: 1,
              properties: { _comucare_for: String(job.mainId) }
            }
          ],
          sections: sections.join(','),
          sections_url: Shopify.routes.root + 'variants/' + job.mainId
        },
        { skipKaching: true }
      );
      var cart = (await fetchCartSafe()) || (detail && detail.cart) || { items: [] };
      cart.sections = careJson.sections;
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
      );
    } catch (error) {
      job.form.dispatchEvent(
        new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } })
      );
    } finally {
      warrantyFulfilling = false;
    }
  }

  document.addEventListener('variant:add', function (event) {
    if (!warrantyFollowUp) return;
    fulfillWarrantyFollowUp(event.detail);
  });

  document.addEventListener(
    'cart:error',
    function () {
      warrantyFollowUp = null;
    },
    true
  );

  // 无套餐：主机+延保一次写入（一台+延保已验证）。
  // 有套餐：不拦截 submit，走主题原表单（三台不加保险已验证），成功后再补延保。
  async function submitWithCare(form, careVariantId) {
    var mainId = readMainId(form);
    if (!mainId) {
      form.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            error:
              (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ja') === 0
                ? '商品仕様を特定できませんでした。セット選択を解除してから再度お試しください。'
                : 'Unable to determine the product variant. Clear the bundle selection and try again.'
          }
        })
      );
      return;
    }

    var quantityInput = form.elements.quantity;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    var properties = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('properties[') !== 0) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      properties[el.name.slice('properties['.length, -1)] = el.value;
    });

    var submitButtons = Array.prototype.filter.call(form.elements, function (el) {
      return el.type === 'submit';
    });
    submitButtons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); });

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );

    try {
      var json = await postCartAdd({
        items: [
          { id: Number(mainId), quantity: quantity, properties: properties },
          { id: Number(careVariantId), quantity: quantity, properties: { _comucare_for: mainId } }
        ],
        sections: sections.join(','),
        sections_url: Shopify.routes.root + 'variants/' + mainId
      });
      var latestSections = json.sections;
      var addedItems = json.items;

      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
        window.location.href = Shopify.routes.root + 'cart';
        return;
      }

      var cart = (await fetchCartSafe()) || { item_count: 0, items: addedItems || [] };
      cart.sections = latestSections;

      form.dispatchEvent(
        new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cart } })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
      );

    } catch (error) {
      // 必须派发在 form 上：Impact 的 buy-buttons 是挂在 form 元素上监听 cart:error 的。
      // 429 后再 cart:refresh 会继续打 cart.js / 抽屉 section，把 HTML 解析成 Unexpected token。
      form.dispatchEvent(
        new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } })
      );
    } finally {
      submitButtons.forEach(function (button) { button.removeAttribute('aria-busy'); });
    }
  }

  /* ---------------------------------------------------------------
     让套餐插件（Kaching）的「价格实时更新」覆盖到所有价格块

     插件是靠一份写死的主题选择器清单找价格的，Impact 那条是
     `.product-info__price compare-at-price`——它只认主题原生的那一个价格块。
     购买区现在有两个 Price block（套餐上方一个、下方一个），
     第二个匹配不到，所以选套餐后金额不跟着变。

     插件留了逃生舱：只要页面上存在 [data-kaching-price] / [data-kaching-price-compare]，
     它就改用这些元素、**完全跳过内置清单**。
     所以必须一次性把所有价格块都标上——只标一个的话，原本能更新的那个反而会失效。

     用 JS 打标记而不是改 snippets/price-list.liquid：那是 Impact 上游的共享片段，
     商品卡、购物车、搜索都在用，动它影响面太大。 */
  function tagKachingPrices() {
    var scopes = document.querySelectorAll('.product-info__price');
    if (!scopes.length) return;

    Array.prototype.forEach.call(scopes, function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('sale-price'), function (el) {
        el.setAttribute('data-kaching-price', '');
      });
      Array.prototype.forEach.call(scope.querySelectorAll('compare-at-price'), function (el) {
        el.setAttribute('data-kaching-price-compare', '');
      });
      /* 折扣角标。插件对它的处理是安全的——只把 innerHTML 里的 `\d+%` 换成新百分比
         （"Save 30%" → "Save 37%"），不会替换整段文案。
         同样必须两个都标：标记一旦存在就取代内置清单，只标一个会让另一个失效。 */
      Array.prototype.forEach.call(scope.querySelectorAll('on-sale-badge'), function (el) {
        el.setAttribute('data-kaching-price-badge', '');
      });
    });
  }

  // 接管提交后，Impact ProductForm 自己的重入锁与 checkValidity 都被绕过了，这里补上
  var careSubmitting = false;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[is="product-form"]')) return;

      var careVariantId = selectedCareVariant(form);
      if (!careVariantId) return;

      // 套餐必须交给主题原表单 + Kaching。我们自己 fetch 会跳过插件的
      // submit 拦截，三台不同配色会 429（不加保险时原表单是成功的）。
      if (formHasBundle(form)) {
        armWarrantyFollowUp(form, careVariantId);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (careSubmitting) return;
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }

      careSubmitting = true;
      submitWithCare(form, careVariantId).then(function () {
        careSubmitting = false;
      }, function () {
        careSubmitting = false;
      });
    },
    true
  );

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-benefits]'), initBenefits);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-description]'), initDescription);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-media-tabs]'), initMediaTabs);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-autoplay]'), initGalleryAutoplay);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-care]'), initCare);
    // 价格标记要在插件首次更新价格之前就位；它每次更新都会重新查询，所以这里补标也有效
    tagKachingPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // 变体切换会重渲染购买区，主题编辑器改设置也会重载 section
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) { initAll(event.target); });
})();
